import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import thumbUpImg from "../images/icons8-thumbs-up-50.png"; // reusing existing image
import { PhoneCall, Target, Rocket, AlertCircle } from "lucide-react";

const ThankYouHealthcare = () => {
    const navigate = useNavigate();

    useEffect(() => {
        if (window.fbq) {
            window.fbq('init', '1307490394763706');
            window.fbq('track', 'Lead');
        }
    }, []);

    return (
        <div className="flex flex-col items-center justify-center min-h-screen w-90 relative overflow-hidden pt-8 bg-gray-50 font-poppins px-4">
            <div className="max-w-3xl w-full flex flex-col items-center space-y-6 bg-white p-8 md:p-10 rounded-2xl shadow-xl text-center border-t-8 border-[#3E88FF] transform transition-all hover:scale-[1.01] duration-300">
                <h1 className="text-3xl font-anton tracking-widest cursor-pointer mb-2 flex items-baseline" onClick={() => navigate("/")}>
                    DUMOSH<span className="h-2 w-2 bg-[#FF3E3E] rounded-full ml-1"></span>
                </h1>
                <img
                    src={thumbUpImg}
                    alt="thumbs-up"
                    className="w-24 sm:w-32 hover:scale-110 transition-transform duration-500 ease-in-out drop-shadow-md"
                />
                <h1 className="text-4xl md:text-5xl font-extrabold text-[#3E88FF] tracking-tight">Thank You!</h1>
                <p className="mt-2 text-xl md:text-2xl font-bold text-gray-800">
                    Your details are submitted. Now the real work begins.
                </p>
                <p className="text-gray-600 mt-2 text-base md:text-lg max-w-lg">
                    Our team is reviewing your requirements and will reach out shortly.
                </p>

                <div className="bg-blue-50 w-full mt-8 p-6 md:p-8 rounded-xl text-left border border-blue-100 shadow-inner">
                    <h3 className="font-bold text-xl text-blue-900 mb-5 border-b-2 border-blue-200 pb-3">Next steps:</h3>
                    <ul className="space-y-5 text-gray-700 font-medium">
                        <li className="flex items-start bg-white p-4 rounded-lg shadow-sm border border-gray-100">
                            <span className="mr-4 bg-blue-100 p-2 rounded-full leading-none text-blue-500"><PhoneCall className="w-6 h-6" /></span>
                            <span className="self-center">You'll receive a call/WhatsApp from a DUMOSH expert</span>
                        </li>
                        <li className="flex items-start bg-white p-4 rounded-lg shadow-sm border border-gray-100">
                            <span className="mr-4 bg-blue-100 p-2 rounded-full leading-none text-blue-500"><Target className="w-6 h-6" /></span>
                            <span className="self-center">We'll understand your goals + current funnel</span>
                        </li>
                        <li className="flex items-start bg-white p-4 rounded-lg shadow-sm border border-gray-100">
                            <span className="mr-4 bg-blue-100 p-2 rounded-full leading-none text-blue-500"><Rocket className="w-6 h-6" /></span>
                            <span className="self-center">We'll share a clear action plan to improve conversions</span>
                        </li>
                    </ul>
                </div>

                <div className="mt-8 font-semibold text-gray-800 bg-yellow-50 px-6 py-4 rounded-xl w-full border-l-4 border-yellow-400 flex items-center justify-center shadow-sm">
                    <AlertCircle className="text-yellow-500 w-6 h-6 mr-3" />
                    <span><span className="font-extrabold text-yellow-800">To speed things up:</span> keep your phone available.</span>
                </div>

                <button
                    className="w-full sm:w-auto mt-8 px-10 py-4 bg-[#3E88FF] text-white rounded-lg hover:bg-blue-700 transition font-bold text-lg shadow-lg hover:shadow-xl"
                    onClick={() => navigate("/interactive-healthcare")}
                >
                    Back to Assessment
                </button>
            </div>
        </div>
    );
};

export default ThankYouHealthcare;
